import { defineAction } from '~/prix'
import actionJson from './roadMaintenanceImageUpdate.action.json' with { type: 'json' }
import { roadMaintenanceImageObject } from '../roadMaintenanceImageObject'
import { z } from 'zod'

const definition = defineAction({
  ...actionJson,
  input: roadMaintenanceImageObject
    .pick({
      id: true,
      description: true,
      position: true,
      status: true,
    })
    .partial()
    .required({ id: true }),
  output: roadMaintenanceImageObject,
})

export default definition
